import React, { useState } from 'react';
import { Row, Col, Button, Modal, Form, InputGroup } from 'react-bootstrap';
// utils
import { handlerErrors } from 'utils/handleErrors';
import { toUpperIfString } from 'utils/textFormat';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// components
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
import { ToastSuccess } from '../../../../components/alerts/toast';
// API
import { editUserBilling } from '../../../api/Api-admin';

const EditUserBillingModal = ({ isModalOpen, setIsModalOpen, data, setUpdatePage }) => {
  // console.log('---->', data);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState({
    crm: data.crm_user_id,
    name: toUpperIfString(data.customer),
    rfc: data.tax_id,
    system: data.tax_system,
    street: toUpperIfString(data.street),
    streetNumber: data.street_number,
    zip: data.zip_code,
    neighborhood: toUpperIfString(data.neighborhood),
    city: toUpperIfString(data.city),
    state: toUpperIfString(data.state),
    email: data.billing_email,
    autoInvoice: data.automatic_invoice,
    autoBalance: data.automatic_balance,
  });
  const handlerEditUserBilling = async () => {
    try {
      setIsAddChargerLoader(true); // active loader in the button
      const response = await editUserBilling(dataToUpdate);
      // console.log('response edit billing:', response);
      if (response.success !== undefined) {
        setUpdatePage(true);
        ToastSuccess(response.message);
        setIsModalOpen(false);
      }
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsAddChargerLoader(false);
    }
  };

  return (
    <Modal size="lg" show={isModalOpen} onHide={() => setIsModalOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">Editar datos de facturación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col lg="8" className="position-relative">
              <Form.Label>Nombre</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="user" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  value={dataToUpdate.name}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, name: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>

              {/* {addressError.name && <div className={`invalid-tooltip ${addressError.name ? 'd-block' : 'd-none'}`}>{addressError.name}</div>} */}
            </Col>
            <Col lg="4" className="position-relative">
              <Form.Label>RFC</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="shield" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  value={dataToUpdate.rfc}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, rfc: e.target.value });
                  }}
                />
              </InputGroup>

              {/* {addressError.company && <div className={`invalid-tooltip ${addressError.company ? 'd-block' : 'd-none'}`}>{addressError.company}</div>} */}
            </Col>

            <Col lg="8" className="position-relative">
              <Form.Label>Correo</Form.Label> <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="email" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  type="email"
                  value={dataToUpdate.email}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, email: e.target.value });
                  }}
                />
              </InputGroup>
              {/* {addressError.email && <div className={`invalid-tooltip ${addressError.email ? 'd-block' : 'd-none'}`}>{addressError.email}</div>} */}
            </Col>
            <Col md="4" lg="4" className="position-relative">
              <Form.Label>Régimen</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="suitcase" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.system}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, system: e.target.value });
                  }}
                />
              </InputGroup>
              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col md="8" lg="8" className="position-relative">
              <Form.Label>Calle</Form.Label> <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="destination" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  required
                  value={dataToUpdate.street}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, street: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>
              {/* {addressError.email && <div className={`invalid-tooltip ${addressError.email ? 'd-block' : 'd-none'}`}>{addressError.email}</div>} */}
            </Col>
            <Col md="4" lg="4" className="position-relative">
              <Form.Label>Número</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="sign" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.streetNumber}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, streetNumber: e.target.value });
                  }}
                />
              </InputGroup>

              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col md="8" lg="8" className="position-relative">
              <Form.Label>Colonia</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="pin" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.neighborhood}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, neighborhood: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>

              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col md="4" lg="4" className="position-relative">
              <Form.Label>C.P.</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="pin" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.zip}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, zip: e.target.value });
                  }}
                />
              </InputGroup>

              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col md="8" lg="6" className="position-relative">
              <Form.Label>Ciudad</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="building" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.city}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, city: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>

              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col lg="6" className="position-relative">
              <Form.Label>Estado</Form.Label>
              <span className="text-primary">*</span>
              <InputGroup>
                <InputGroup.Text>
                  <CsLineIcons icon="image" size="16" className="text-alternate" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={dataToUpdate.state}
                  onChange={(e) => {
                    // setAddressError({ ...addressError, name: false });
                    setDataToUpdate({ ...dataToUpdate, state: e.target.value.toUpperCase() });
                  }}
                />
              </InputGroup>

              {/* {addressError.phone && <div className={`invalid-tooltip ${addressError.phone ? 'd-block' : 'd-none'}`}>{addressError.phone}</div>} */}
            </Col>
            <Col lg="6">
              <Form.Label>Comprobantes Automáticos</Form.Label>
              <span className="text-primary">*</span>
              <div style={{ position: 'relative', zIndex: 1, maxWidth: '200px' }}>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="autoInvoice"
                    value="true"
                    className="form-check-input me-2"
                    checked={dataToUpdate.autoInvoice === true}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, autoInvoice: true })}
                  />
                  <label className="form-check-label">Sí</label>
                </div>
                <div className="form-check ms-2">
                  <input
                    type="radio"
                    name="autoInvoice"
                    value="false"
                    className="form-check-input me-2"
                    checked={dataToUpdate.autoInvoice === false}
                    onChange={() => setDataToUpdate({ ...dataToUpdate, autoInvoice: false })}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </Col>
            <Col lg="6">
              <Form.Label>Saldo Automatico</Form.Label>
              <span className="text-primary">*</span>
              <div style={{ position: 'relative', zIndex: 1, maxWidth: '200px' }}>
                <div className="ms-2">
                  {/* address from */}
                  <input
                    type="radio"
                    name="autoBalance"
                    value="true"
                    className="form-check-input me-2"
                    checked={dataToUpdate.autoBalance === true}
                    onClick={() => {
                      // setAddressErr({ ...addressErr, addressType: false });
                      setDataToUpdate({ ...dataToUpdate, autoBalance: true });
                    }}
                  />
                  <label className="form-label">Si</label>
                </div>
                <div className="ms-2">
                  {/* address to */}
                  <input
                    type="radio"
                    name="autoBalance"
                    value="false"
                    className="form-check-input me-2"
                    checked={dataToUpdate.autoBalance === false}
                    onClick={() => {
                      // setAddressErr({ ...addressErr, addressType: false });
                      setDataToUpdate({ ...dataToUpdate, autoBalance: false });
                    }}
                  />
                  <label className="form-label">No</label>
                </div>
                {/* {addressErr.addressType && <div className={`invalid-tooltip ${addressErr.addressType ? 'd-block' : 'd-none'}`}>{addressErr.addressType}</div>} */}
              </div>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => setIsModalOpen(false)} style={{ height: '36px' }} className="ms-2">
          Cancelar
        </Button>
        <ButtonRequest
          title="Editar"
          titleLoading="Editando"
          handlerFn={handlerEditUserBilling}
          isButtonDisabled={isAddChargerLoader}
          isLoading={isAddChargerLoader}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EditUserBillingModal;
